// extracted by mini-css-extract-plugin
export default {"root":"MerchantRedirect_root__9RFzE","button":"MerchantRedirect_button__s+Bdp"};